import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';

import { displayAPIError, formTemplatesContainerPosition } from '../../utils/utils';
import CurrentFormTemplateContainer from './CurrentFormTemplateContainer';
import EditTemplateContainer from './EditTemplateContainer';
import FormTemplateError from './FormTemplateError';
import FormTemplateTrialContainersContainer from './FormTemplateTrialContainersContainer';
import FormTemplateVersionsContainer from './FormTemplateVersionsContainer';
import FormTemplateWorkflowsContainer from './FormTemplateWorkflowsContainer';
import HomepageContainer from './HomepageContainer';
import NewFormTemplateContainer from './NewFormTemplateContainer';
import ScrollToPosition from './ScrollToPosition';
import ViewFormTemplateVersionContainer from './ViewFormTemplateVersionContainer';

function FormTemplateContainer(props) {
  const { formTemplateRequest } = props;
  const { error, requestType } = formTemplateRequest;

  const { xCord, yCord, behavior } = formTemplatesContainerPosition;

  if (displayAPIError(error) && requestType === 'fetch') {
    return <FormTemplateError source="api" handleLog />;
  }

  return (
    <ScrollToPosition xCord={xCord} yCord={yCord} behavior={behavior}>
      <Switch>
        <Route
          exact
          path="/"
          render={() => {
            return (
              <CurrentFormTemplateContainer>
                <HomepageContainer />
              </CurrentFormTemplateContainer>
            );
          }}
        />
        <Route
          exact
          path="/new"
          render={() => {
            return (
              <CurrentFormTemplateContainer>
                <NewFormTemplateContainer />
              </CurrentFormTemplateContainer>
            );
          }}
        />
        <Route
          path="/:templateId/edit"
          render={() => {
            return (
              <CurrentFormTemplateContainer>
                <EditTemplateContainer />
              </CurrentFormTemplateContainer>
            );
          }}
        />
        <Route
          path="/:templateId/workflows"
          render={() => {
            return (
              <CurrentFormTemplateContainer>
                <FormTemplateWorkflowsContainer />
              </CurrentFormTemplateContainer>
            );
          }}
        />
        <Route
          path="/:templateId/trial_containers"
          render={() => {
            return (
              <CurrentFormTemplateContainer>
                <FormTemplateTrialContainersContainer />
              </CurrentFormTemplateContainer>
            );
          }}
        />
        <Route
          path="/:templateId/versions/:version_number"
          render={() => {
            return (
              <CurrentFormTemplateContainer>
                <ViewFormTemplateVersionContainer />
              </CurrentFormTemplateContainer>
            );
          }}
        />
        <Route
          path="/:templateId/versions"
          render={() => {
            return (
              <CurrentFormTemplateContainer>
                <FormTemplateVersionsContainer />
              </CurrentFormTemplateContainer>
            );
          }}
        />
        <Route
          exact
          path={['/:displaytype']}
          render={() => {
            return (
              <CurrentFormTemplateContainer>
                <HomepageContainer />
              </CurrentFormTemplateContainer>
            );
          }}
        />
        <Route render={() => <Redirect to="/" />} />
      </Switch>
    </ScrollToPosition>
  );
}

FormTemplateContainer.propTypes = {
  formTemplateRequest: PropTypes.shape(),
};

function mapStateToProps(state) {
  return {
    formTemplateRequest: state.formTemplateApiReducer.formTemplateRequest,
  };
}

export default connect(mapStateToProps)(FormTemplateContainer);
